// extracted by mini-css-extract-plugin
module.exports = {"list":"LinksList_list__1yxMx","list__item":"LinksList_list__item__32429"};